import { DataQualityDefinition } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/**
 * Контроль качества AI (БО-40, БО-41; раздел 15.3): обезличенные выборки и их оценка, метрики по версиям промптов
 * и моделей, инциденты критических ошибок и экспорт случая в регрессионный eval-набор. DODOC_QA и DODOC_ADMIN.
 */
export const section = defineSection({
  id: 'backoffice.aiqa',
  area: 'backoffice',
  path: 'aiqa/*',
  roles: ['DODOC_QA', 'DODOC_ADMIN'],
  icon: DataQualityDefinition,
  titleKey: 'aiqa:title',
  namespaces: ['backoffice'],
  navGroup: 'quality',
  order: 200,
  load: () => import('./AiqaPage'),
});
